import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import * as moment from 'moment';

import { ManualPayment } from "src/app/shared/models/invoice/manual-payment.model";

@Component({
  selector: 'app-manual-pay',
  templateUrl: './manual-pay.component.html',
  styleUrls: ['./manual-pay.component.scss']
})
export class ManualPayComponent implements OnInit {
  @ViewChild('manualPayForm', { static: false }) manualForm: HTMLFormElement;

  @Input() isProcessing: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() invoiceBalance: any = 0;
  @Input() invoiceModel: any;
  @Input() type: string = 'merchant'; // merchant or checkout

  @Output() onValueChange: EventEmitter<any> = new EventEmitter();

  manualPayment: ManualPayment = new ManualPayment();
  minPaymentDate: string = moment(new Date()).format('YYYY-MM-DD');
  paymentDate: string;

  selectedPaymentMethod: number | string = '';
  paymentMethods: any = [
    { name: 'Select Method', value: '', enable: true },
    { name: 'Check', value: 1, enable: true },
    { name: 'Bank Transfer', value: 2, enable: true },
    { name: 'Cash', value: 3, enable: this.type !== 'merchant' },
  ];

  ngOnInit() {
    this.minPaymentDate = moment(new Date(this.invoiceModel.invoiceDate)).format('YYYY-MM-DD');
  }

  setPaymentMethod(method: string | number): void {
    this.selectedPaymentMethod = method;

    if (this.selectedPaymentMethod !== '') {
      this.manualPayment.PaymentMethod = this.selectedPaymentMethod as number;
      this.onValueChange.emit(this.manualForm.form);
    }
  }

  setPaymentDate(date: string): void {
    this.paymentDate = date;

    if (this.isValidDate()) {
      this.manualPayment.PaymentDate = new Date(this.paymentDate);
      this.onValueChange.emit(this.manualForm.form);
    }
  }

  isValidDate(): boolean {
    let paymentDate = Date.parse(this.paymentDate);

    return !isNaN(paymentDate);
  }

  onChange(key: string, data: string): void {
    this.manualPayment[key] = data;
    this.onValueChange.emit(this.manualForm.form);
  }
}
